import * as Yup from 'yup';
import { Form, FormikProvider, useFormik } from 'formik';
import { toast } from 'react-toastify';
// @mui
import { Stack, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { sendForgotPasswordEmail } from '../../../services/sendForgotPasswordEmail';
// ----------------------------------------------------------------------

export default function ForgotPassForm() {

    const ValidationSchema = Yup.object({
        email: Yup.string().email('Email must be a valid email address').required('Email is required')
    });

    const formik = useFormik({
        initialValues: {
            email: ''
        },
        validationSchema: ValidationSchema,
        onSubmit: (values) => {
            sendForgotPasswordEmail(values)
                .then((data) => {
                    toast.success(data?.data?.message);
                })
                .catch((error) => {
                    toast.error(error?.response?.data?.message);
                })
                .finally(() => {
                    setSubmitting(false);
                });
        },
    });

    const { errors, touched, handleSubmit, getFieldProps, setSubmitting, isSubmitting } = formik;

    return (
        <>
            <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                    <Stack spacing={3}>
                        <TextField
                            name="email"
                            label="Email address"
                            {...getFieldProps('email')}
                            style={{ marginBottom: '24px' }}
                            error={touched.email && Boolean(errors.email)}
                            helperText={touched.email && errors.email}
                        />
                    </Stack>

                    <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
                        Forgot Password
                    </LoadingButton>
                </Form>
            </FormikProvider>
        </>
    );
}
